import { render, staticRenderFns } from "./VaimoPromoBanner.vue?vue&type=template&id=5661eca3&scoped=true&"
import script from "./VaimoPromoBanner.vue?vue&type=script&lang=ts&"
export * from "./VaimoPromoBanner.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoPromoBanner.vue?vue&type=style&index=0&id=5661eca3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5661eca3",
  null
  
)

export default component.exports